const HashMap = require('./HashMap');

class LinkedHashMap extends HashMap {

    constructor () {
        super();

        // 'inner' Entry class
        this._Entry = function (value) {
            this.prev = null;
            this.next = null;
            this.value = value;
        };

        // doubly linkedlist instance variables
        this._head = this._tail = null;
    }

    /**
     * Puts the key/value pair in the HashMap and records
     * the insertion record if it does not exist.
     *
     * @override HashMap.put()
     */
    put (key, value) {
        let entry = new this._Entry(key);

        if (!this.containsKey(key)) {
            if (this.size() === 0) {
                this._head = entry;
                this._tail = entry;
            } else {
                this._tail.next = entry;
                entry.prev = this._tail;
                this._tail = entry;
            }
        }

        /*
         * EDIT: Added optimization suggested
         * by Chad Walker (see article comments).
         */
        // overwrite the value with an optimized Object wrapper
        value = {value: value, entry: entry};

        super.put(key, value);
    };

    putAfter (startKey, key, value) {
        let entry = new this._Entry(key);

        if (!this.containsKey(key)) {
            let startValue = this.getEntry(startKey);
            if (!startValue || this.size === 0) {
                this.put(key, value);
                return false;
            } else {
                let startEntry = startValue.entry;
                entry.prev = startEntry;
                entry.next = startEntry.next;
                startEntry.next = entry;
                if (this._tail === startEntry) {
                    this._tail = entry;
                }
            }
        }

        value = {value: value, entry: entry};

        super.put(key, value);
    };

    getEntry (key) {
        return super.get(key);
    };

    /**
     * Returns the value associated with the key.
     *
     * @override HashMap.get()
     */
    get (key) {
        let value = super.get(key);

        /*
         * EDIT: Added optimization suggested
         * by Chad Walker (see article comments).
         */
        // we must unwrap the value
        return value !== null ? value.value : null;
    };

    /**
     * Removes the key/value pair from the map and
     * the key from the insertion order.
     *
     * @override Hashmap.remove()
     */
    remove (key) {
        /*
         * EDIT: Added optimization suggested
         * by Chad Walker (see article comments).
         */
        let value = super.remove(key);

        if (value !== null) {

            let entry = value.entry;

            if (entry === this._head) {
                this._head = entry.next;
                this._head.prev = null;
            } else if (entry === this._tail) {
                this._tail = entry.prev;
                this._tail.next = null;
            } else if(entry.next && entry.prev){
                entry.prev.next = entry.next;
                entry.next.prev = entry.prev;
            }
        }

        return value;
    };

    /**
     * Clears the HashMap and insertion order.
     *
     * @override HashMap.clear()
     */
    clear () {
        super.clear();
        this._head = this._tail = null;
    };

    /**
     * Returns the HashMap keys in insertion order.
     *
     * @override HashMap.keys()
     */
    keys () {
        let keys = [];
        for (let cur = this._head; cur !== null; cur = cur.next) {
            keys.push(cur.value);
        }
        return keys;
    };

    /**
     * Returns the HashMap values in insertion order.
     *
     * @override HashMap.values()
     */
    values () {
        let values = [];
        for (let cur = this._head; cur !== null; cur = cur.next) {
            values.push(this.get(cur.value));
        }
        return values;
    };

}

module.exports = LinkedHashMap;


